import toMaterialStyle from 'material-color-hash';
import { TinyColor } from '@ctrl/tinycolor';

/**
 * Generate a HSL color from a key using material-color-hash.
 * @param {string} key
 * @returns {string}
 */
function generateColorFromKey(key) {
    const MIN_SHIFT = 180;
    const MAX_SHIFT = 360;
    const HASH_MULTIPLIER = 10;
    const SATURATION_MULTIPLIER = 0.6;
    const LIGHTNESS_MULTIPLIER = 0.7;

    const { backgroundColor } = toMaterialStyle(String(key ?? ''));

    // Convert the background color to a TinyColor object
    const tinyColor = new TinyColor(backgroundColor);

    // Get the HSL values of the background color
    const hsl = tinyColor.toHsl();

    // Improve differentiation using key hash
    const hash = Array.from(String(key ?? '')).reduce(
        (acc, char) => acc + char.charCodeAt(0) * HASH_MULTIPLIER,
        0
    );

    // Shift the hue by the hash value
    const hueShift = hash % MIN_SHIFT;

    // Return the new color in HSL string format
    return new TinyColor({
        h: (hsl.h + hueShift) % MAX_SHIFT,
        s: Math.min(SATURATION_MULTIPLIER, hsl.s + 0.2),
        l: Math.max(LIGHTNESS_MULTIPLIER, hsl.l)
    }).toHslString();
}

export default generateColorFromKey;